<template>
    <el-dialog
        title="Filter Data"
        :visible.sync="internalVisible"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
        <div class="mb-2">
            <label class="form-control-label">Title</label>
            <input placeholder="title" type="text" class="form-control" v-model="filter.title" />
        </div>
        <div class="mb-2">
            <label class="form-control-label">Date</label>
            <input placeholder="title" type="date" class="form-control" v-model="filter.created_at" />
        </div>
        <div class="mb-4">
            <label class="form-control-label">Company</label><br>
            <el-select
                class="w-100"
                v-model="filter.company_code"
                :placeholder="tt('choose_company')"
                filterable remote
                reserve-keyword
                clearable
                :loading="loadingGeSalesOrgs"
            >
                <el-option
                   v-for="so in sales_orgs" :key="'sales' + so.sales_org_code"
                    :label="so.sales_org_code + ' - ' + so.sales_org_description"
                    :value="so.sales_org_code"
                />
            </el-select>
        </div>
        <div class="d-flex justify-content-end">
            <base-button type="light" @click="handleClose" :loading="loadingFilter">Batal</base-button>
            <base-button type="primary" @click="submit" :loading="loadingFilter">Submit</base-button>
        </div>
    </el-dialog>
</template>

<script>
import salesOrganization from '@/services/master/salesOrganization.service';
import Api from '@/helpers/api';

export default {
    name: 'ModalFilter',
    data() {
        return {
            sales_orgs: [],
            loadingGeSalesOrgs: false
        }
    },
    props: {
        filter: {
            type: Object,
            required: true,
            default() {
                return {
                    company_code: '',
                    title: '',
                    created_at: ''
                };
            }
        },
        visibleModalFilter: {
            type: Boolean,
            required: false
        },
        loadingFilter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        internalVisible: {
            get() {
                return this.visibleModalFilter;
            },
            set(val) {
                this.$emit('update:visibleModalFilter', val);
            }
        }
    },
    mounted() {
        this.fetchSalesOrgs()
    },
    methods: {
        handleClose() {
            this.internalVisible = false;
        },
        submit() {
            this.$emit('submit-filter');
        },
        fetchSalesOrgs(){
            this.loadingGeSalesOrgs = true

            Api(this, salesOrganization.get(null,{per_page: 'none'}))
            .onSuccess((response) => {   
                this.sales_orgs = response?.data?.data?.data?.data
            }).onError(function(error) {
                this.sales_orgs = []
            })
            .onFinish(() => {
                this.loadingGeSalesOrgs = false
            })
            .call()
        }
    }
};
</script>
